import React from "react";
import { X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "./dialog";
import { Button } from "./button";

interface PauseStackModalProps {
  isOpen: boolean;
  onConfirmPause: () => void;
  setIsPauseDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
  description?: string;
  confirmButtonText?: string;
}

export default function PauseStackModal({
  isOpen,
  onConfirmPause,
  setIsPauseDialogOpen,
  title = "Pause your stack?",
  description = "Pausing will stop AutoStacking your amounts. Your current stacked assets won't be affected.",
  confirmButtonText = "Pause AutoStack",
}: PauseStackModalProps) {
  const handleConfirmPause = () => {
    onConfirmPause();
    setIsPauseDialogOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsPauseDialogOpen}>
      <DialogContent className="max-w-md p-0 bg-white rounded-xl border-0 shadow-2xl">
        <div className="relative p-6">
          <DialogClose className="border border-bg-neutral rounded-full p-2 flex justify-end ml-auto opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none">
            <X className="h-5 w-5 text-text-light" />
            <span className="sr-only">Close</span>
          </DialogClose>

          <div className="space-y-4">
            <DialogTitle className="text-2xl font-semibold text-brand-primary">
              {title}
            </DialogTitle>

            <DialogDescription className="text-base text-text-secondary leading-relaxed">
              {description}
            </DialogDescription>

            <div className="flex justify-center pt-4">
              <Button
                onClick={handleConfirmPause}
                className="btn-primary max-w-72 !p-6"
              >
                {confirmButtonText}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
